import { useTranslations } from 'contexts/Translation'
import { HeaderBreadcrumbs, Spinner } from 'components'
import { PageWrapper, Row, Col } from '@qonsoll/react-design'
import { useParams } from 'react-router-dom'
import { RewardAdvancedForm } from 'domains/Reward/components'
import {
  useGetRewardInitialValues,
  useRewardBaseActions
} from 'domains/Reward/hooks'

const RewardEditPage = (props) => {
  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting params from router */
  const { rewardId } = useParams()

  /* Fetching reward initial values */
  const [initialValues, loading] = useGetRewardInitialValues(rewardId)
  /* Getting base actions */
  const { onBack } = useRewardBaseActions()

  /* Configuring page header */
  const headingProps = {
    title: t('Reward edit'),
    titleSize: 3,
    marginBottom: 3,
    textAlign: 'left'
  }

  return (
    <PageWrapper
      onBack={onBack}
      breadcrumbs={<HeaderBreadcrumbs />}
      headingProps={headingProps}>
      <Row noGutters>
        {loading ? (
          <Col>
            <Spinner height="70vh" text={t('Reward loading')} />
          </Col>
        ) : (
          <Col cw={[12, 12, 10, 8, 7]}>
            <RewardAdvancedForm initialData={initialValues} />
          </Col>
        )}
      </Row>
    </PageWrapper>
  )
}

export default RewardEditPage
